import moment from 'moment'
import map  from 'lodash.map'
import {
  CLOUD_ACCOUNTS_PENDING,
  CLOUD_ACCOUNTS_SUCCESS,
  CLOUD_ACCOUNTS_ERROR,

  CLOUD_BUCKETS_PENDING, CLOUD_BUCKETS_SUCCESS, CLOUD_BUCKETS_ERROR,
  CLOUDS_PENDING, CLOUDS_SUCCESS, CLOUDS_ERROR ,

  CLOUD_ACCOUNT_EXPANDED,
  SEARCH_ACCOUNT,
  SELECT_ACCOUNT,
  SELECT_REGION,
  SELECT_CREATED,
  SELECT_COST,
  SELECT_USAGE,
  SELECT_COST_RANGE,
  SELECT_USAGE_RANGE,
  DELETE_CLOUD_ACCOUNT_SUCCESS
} from '../actions/cloud-accounts-actions'

const initialState = {
  items: [],
  error: null,
  loading: false,
  accounts_loading: false,
  bucket_loading:false,
  expandedItemId: null,
  filter: {
    search: '',
    items: null,
    cost: {
      min: 0,
      max: 100,
      value: [0, 100]
    },
    usage: {
      min: 0,
      max: 100,
      value: [0, 100]
    }
  }
}

export default function cloudAccounts(state = initialState, action = {}) {
  switch (action.type) {

    case CLOUD_BUCKETS_PENDING:
      return { ...state, bucket_loading: true}

    case CLOUD_BUCKETS_SUCCESS:
      // console.log("i am in bucket success",state.items);
      // console.log("i am in bucket success",action.buckets.length);
    // console.log("action.buckets", action.data.buckets.length);

      return {
        ...state,
        items: state.items.map(c => c.id === (action||{}).data.id ? {...c, storages: (action||{}).data.buckets, bucket_count :((action||{}).data.buckets||[]).length}: c),
        loading: false,
        accounts_loading: false,
        bucket_loading:false
      }

    case CLOUD_BUCKETS_ERROR:
      return {
        ...state,
        items: state.items.map(c => c.id === ((action||{}).data||{}).id ? {...c, storages: []}: c),
        loading: false,
        accounts_loading: false,
        bucket_loading:false
      }

    case CLOUDS_PENDING:
      return { ...state, loading: true, accounts_loading: true }

    case CLOUDS_SUCCESS:
      let max_usage, max_cost = 100
      try {
         max_usage = Math.floor(Math.max(...map((action||{}).data, 'total_bytes_used')) / Math.pow(1024, 3)) + 2
         max_cost = Math.floor(Math.max(...map((action||{}).data, 'total_cost'))) + 1
        if(max_usage === -Infinity || isNaN(max_usage)) {
          max_usage = 100
        }
        if(max_cost === -Infinity || isNaN(max_cost)) {
          max_cost = 100
        }

        for (let key in (action||{}).data) {
          (action||{}).data[key].storages = (((state.items.filter(c=>c.id === (action||{}).data[key].id)||[])[0]||{}).storages || [])

          for (let j = 0; j < (action||{}).data[key].storages.length; j++) {
            ((action||{}).data[key].storages[j]||{}).access_key = ((action||{}).data[key].info||{}).access_key;
          }
        }
      } catch (e){
        console.error(e)
      }

      return {
        ...state,
        items: (action||{}).data,
        loading: false,
        accounts_loading: false,
        filter: {
          ...state.filter,
          usage: {
            ...state.filter.cost,
            max: max_usage,
            value: [0, max_usage]
          },
          cost: {
            ...state.filter.usage,
            max: max_cost,
            value: [0, max_cost]
          }
        }
      }

    case CLOUDS_ERROR:
      return { ...state, loading: false, accounts_loading: false, items: [], error: action.message }

    case CLOUD_ACCOUNTS_PENDING:
      return { ...state, loading: true, accounts_loading: true }

    case CLOUD_ACCOUNTS_SUCCESS:
      let maxUsage, maxCost = 100
      try {
        maxUsage = Math.floor(Math.max(...map((action||{}).data, 'total_bytes_used')) / Math.pow(1024, 3)) + 2
        maxCost = Math.floor(Math.max(...map((action||{}).data, 'total_cost'))) + 1
        if(maxUsage === -Infinity || isNaN(maxUsage)) {
          maxUsage = 100
        }
        if(maxCost === -Infinity || isNaN(maxCost)) {
          maxCost = 100
        }
        // console.log("in reducer",action.data);
        
      } catch (e){
        console.error(e)
      }

      return {
        ...state,
        items            : (action||{}).data,
        loading          : false,
        accounts_loading : false,

        filter: {
          ...state.filter,
          usage: {
            ...state.filter.cost,
            max: maxUsage,
            value: [0, maxUsage]
          },
          cost: {
            ...state.filter.usage,
            max: maxCost,
            value: [0, maxCost]
          }
        }
      }

    case CLOUD_ACCOUNTS_ERROR:
      return { ...state, loading: false, accounts_loading: false, items: [], error: action.message }

    case CLOUD_ACCOUNT_EXPANDED:
      if (state.expandedItemId === (action||{}).data) {
        return {
          ...state,
          expandedItemId : null,
          items : state.items.map(i =>
            ({
              ...i,
              storages : i.storages.map(s =>({ ...s, hidden: false }))
            }))
        }
      }
      return {
        ...state,
        expandedItemId: (action||{}).data
      }

    case SEARCH_ACCOUNT:
      const search = (action||{}).data
      filteredItems = state.items.map(item => {
        if (item.id === state.expandedItemId) {
          item.storages = item.storages.map(storage => {
            const visible = search.length === 0 || storage.bucket_name.search(new RegExp(search, 'i')) !== -1
            return { ...storage, hidden: !visible }
          })
        }
        return item
      })
      return { ...state, items: filteredItems, filter: { ...state.filter, search } }

    case SELECT_ACCOUNT:
      const selectedAccount = (action||{}).data
      let filteredItems = selectedAccount !== 'all'
        ? state.items.filter(i => i.account_type_id === selectedAccount)
        : null
      return {
        ...state,
        filter: { ...state.filter, items: filteredItems }
      }

    case SELECT_REGION:
      const selectedRegion = (action||{}).data
      filteredItems = state.items.map(item => {
        if (item.id === state.expandedItemId) {
          item.storages = item.storages.map(storage => {
            const visible = selectedRegion === 'all' || storage.region === selectedRegion
            return { ...storage, hidden: !visible }
          })
        }
        return item
      })
      return { ...state, items: filteredItems }

    case SELECT_CREATED:
      const selectedCreated = (action||{}).data
      const [from, to] = selectedCreated
      filteredItems = state.items.map(item => {
        if (item.id === state.expandedItemId) {
          item.storages = item.storages.map(storage => {
            const visible = selectedCreated.length === 0 || moment(storage.created_on).isBetween(from, to)
            return { ...storage, hidden: !visible }
          })
        }
        return item
      })
      return { ...state, items: filteredItems }

    case SELECT_COST:
      const selectedCost = (action||{}).data
      return {
        ...state,
        filter: {
          ...state.filter,
          cost: {
            ...state.filter.cost,
            value: selectedCost
          }
        }
      }

    case SELECT_USAGE:
      const selectedUsage = (action||{}).data
      return {
        ...state,
        filter: {
          ...state.filter,
          usage: {
            ...state.filter.usage,
            value: selectedUsage
          }
        }
      }

    case SELECT_COST_RANGE:
      const selectedCostRange = (action||{}).data
      let min = selectedCostRange[0]
      let max = selectedCostRange[1]
      return {
        ...state,
        filter: {
          ...state.filter,
          items: state.items.filter(i => min <= i.total_cost && i.total_cost <= max)
        }
      }

    case SELECT_USAGE_RANGE:
      const selectedUsageRange = (action||{}).data
      min = selectedUsageRange[0] * Math.pow(1024, 3)
      max = selectedUsageRange[1] * Math.pow(1024, 3)
      return {
        ...state,
        filter: {
          ...state.filter,
          items: state.items.filter(i => min <= i.total_bytes_used && i.total_bytes_used <= max)
        }
      }

    case DELETE_CLOUD_ACCOUNT_SUCCESS:
      const cloudAccountId = (action||{}).data
      return {
        ...state,
        items: state.items.filter(i => i.id !== cloudAccountId)
      }
    default:
      return state
  }
}
